import React, { Component } from 'react'
import './ArticlePage.scss'
import { getArticleById } from '../../../src/api/brands';
import images from '../../../src/ressources/images'
import InsComments from '../InsComments/InsComments';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { addLike } from '../../api/news';
import FormationItem from '../FormationItem/FormationItem';
import BrandArticlesItem from '../Brands/BrandArticlesItem/BrandArticlesItem';
import InsLoader from '../InsLoader/InsLoader';
import { Redirect } from "react-router-dom";

export class ArticlePage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      content: '',
      articleId : this.props.match.params.id,
      dataArticle: {},
      loading: true
    };
  }

  UNSAFE_componentWillMount(){
    let currentIdArticle = document.location.href.split('/');
    currentIdArticle = currentIdArticle[currentIdArticle.length-1];
    this.setState({articleId: currentIdArticle});
  }

  componentDidMount(){
    this.getArticleByIdFront();
    this.addZoomViewPortMetaTag();
  }
  
  componentWillUnmount() {
    if (this.metaTag) {
      document.head.removeChild(this.metaTag);
    }
    this.setActualViewport();
  }

  addZoomViewPortMetaTag() {
    const metaTag = document.createElement('meta');
    metaTag.name = 'viewport';
    metaTag.content = 'width=device-width, initial-scale=1.0, maximum-scale=3, user-scalable=yes';
    document.head.appendChild(metaTag);
    this.metaTag = metaTag;
  }

  setActualViewport() {
    const actualViewportMeta = document.createElement('meta');
    actualViewportMeta.name = 'viewport';
    actualViewportMeta.content = 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no';
    document.head.appendChild(actualViewportMeta);
    setTimeout(() => {
      document.head.removeChild(actualViewportMeta);
    }, 200);
  }

  addLike = () => {
    let {articleId} = this.state
    addLike(articleId).then((data) => {
      this.setState(prevState => ({
        dataArticle: {
            ...prevState.dataArticle,
            likes: data.likes,
            isLiked: data.isLiked
        }
      }))
    })
  }

  getArticleByIdFront = () => {
    const {articleId} = this.state
    getArticleById(articleId).then((data) =>{
      this.setState({dataArticle: data, loading: false})
      try {
        window.instgrm.Embeds.process()
      } catch (error) {
        console.log(error)
      }
    })
    .catch((err) => {
      this.setState({ redirect: true });
    });
  }

  /**
   * Retour à la page précédente
   */
  _goBack = () => {
    const { history, location } = this.props;

    if(location.state && location.state.transitionName){
      history.goBack();
    } else {
      history.goBack();
    }
  }

  render() {
    const {articleId, dataArticle, loading, redirect} = this.state
    const {account, t} = this.props
    const {associated_article, associated_course,brand, content, title, subtitle, picture, isLiked, likes} = dataArticle

    if (redirect) {
      return <Redirect to="/" />;
    }

    return(
      <div className="page_wrapper">
       {loading ?
          <InsLoader/>
        :
        <div className="content_container bg_white">
            <div className="back_link-article" onClick={this._goBack}>
            <img className="white-arrow--left" src={images.arrow_left_white} alt=""/>
          </div>
          <div className="news_likes">
            <div className={isLiked ? 'like_icon liked' : 'like_icon'} onClick={this.addLike}></div>
            <div className="like_count">{likes}</div>
          </div>
          {/* <img className="love-icon--white" src={images.love_icon_white} alt="" /> */}
          {
            picture === null ?
            <img className="content_picture" src={images.bg_none} alt="" /> :
            <img className="content_picture" src={picture} alt="" />
          }
          <div className="article_content">
            <p className="content_brand">{brand}</p>
            <p className="content_title">{title}</p>
            <p className="content_subtitle">{subtitle}</p>
            <p className="main_separator"></p>
            <div className="content--bo">
              <div dangerouslySetInnerHTML={{ __html: content }} />
            </div>
          </div>
          <div className="article_footer">
              <div className="comments">
                <InsComments
                  currentUserAvatar={account.picture}
                  contentId={articleId}
                  callApi="articles"
                />
              </div>
              {associated_article || associated_course ? <p className="separator"></p> : null}
              <div className="cross">
                {associated_article.length > 0 &&
                  <>
                    <div className="title">{t('cross_univers')}</div>
                    {associated_article.map((article) =>
                      <div key={article.id}>
                        <BrandArticlesItem
                          key={article.id}
                          id={article.id}
                          title={article.title}
                          subtitle={article.subtitle}
                          picture={article.picture}
                          content={article.content}
                          brandId={article.brand_id}
                        />
                      </div>
                    )}
                  </>
                }
                {associated_course.length > 0 &&
                  <>
                    <div className="title">{t('cross_course')}</div>
                    {associated_course.map((course) =>
                      <div key={course.id}>
                        <FormationItem
                          brand={course.brand}
                          image={course.picture}
                          title={course.title}
                          formation={course.type}
                          time={course.time}
                          points={course.points}
                          idFormation={course.id}
                          pourcent={course.pourcent}
                        />
                      </div>
                    )}
                  </>
                }
              </div>
            </div>
        </div>
        }
      </div>
    )

  }
}
//extract data from the redux store
const mapStateToProps = (state) => ({
  account: state.account,
  navigation: state.navigation
})

export default (connect(mapStateToProps)(withTranslation()(ArticlePage)))
